<template>
  <div class="flex flex-col items-center min-h-screen w-full bg-gray-100">
    <cabecera-gob-mx />
    
    <div class="rounded-lg shadow-lg w-5/6 min-w-sm max-w-md p-8 m-4 lg:my-12 flex-1 mx-auto shadow border bg-white">
      <div class="flex">
        <img v-if="url_image !== ''" :src="replaceURL(url_image)" alt="" />
      </div>

      <h1 class="text-center text-4xl font-bold my-5">
        {{ app_name }}
      </h1>

      <div class="w-full my-3">
        <form
          id="signInForm"
          @submit.prevent="loginSubmit"
        >
          <h2 class="w-full text-2xl">
            Inicio de Sesión
          </h2>
          
          <div class="my-3">
            <label
              class="block uppercase tracking-wide text-xs font-bold mb-2 text-left"
              for="email"
              >Correo electrónico</label
            >
            <input
              class="appearance-none block w-full bg-gray-200 text-black border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
              id="email"
              type="text"
              name="email"
              v-model="email"
            />
          </div>

          <div class="my-3">
            <label
              class="block uppercase tracking-wide text-xs font-bold mb-2 text-left"
              for="password"
              >Contraseña</label
            >
            <div class="relative">
              <input
                class="appearance-none block w-full bg-gray-200 text-black border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                id="password"
                :type="showPassword ? 'text' : 'password'"
                name="password"
                v-model="password"
              />
              <div
                class="absolute inset-y-0 right-0 pr-2 flex items-center cursor-pointer select-none"
                v-on:click="changePasswordVisibility()"
              >
                <svg
                  v-if="!showPassword"
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6 fill-current"
                  viewBox="0 -960 960 960"
                >
                  <path
                    d="M480-320q75 0 127.5-52.5T660-500q0-75-52.5-127.5T480-680q-75 0-127.5 52.5T300-500q0 75 52.5 127.5T480-320Zm0-72q-45 0-76.5-31.5T372-500q0-45 31.5-76.5T480-608q45 0 76.5 31.5T588-500q0 45-31.5 76.5T480-392Zm0 192q-146 0-266-81.5T40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200Zm0-300Zm0 220q113 0 207.5-59.5T832-500q-50-101-144.5-160.5T480-720q-113 0-207.5 59.5T128-500q50 101 144.5 160.5T480-280Z"
                  />
                </svg>
                <svg
                  v-else
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6 fill-current"
                  viewBox="0 -960 960 960"
                >
                  <path
                    d="m644-428-58-58q9-47-27-88t-93-32l-58-58q17-8 34.5-12t37.5-4q75 0 127.5 52.5T660-500q0 20-4 37.5T644-428Zm128 126-58-56q38-29 67.5-63.5T832-500q-50-101-143.5-160.5T480-720q-29 0-57 4t-55 12l-62-62q41-17 84-25.5t90-8.5q151 0 269 83.5T920-500q-23 59-60.5 109.5T772-302Zm20 246L624-222q-35 11-70.5 16.5T480-200q-151 0-269-83.5T40-500q21-53 53-98.5t73-81.5L56-792l56-56 736 736-56 56ZM222-624q-29 26-53 57t-41 67q50 101 143.5 160.5T480-280q20 0 39-2.5t39-5.5l-36-38q-11 3-21 4.5t-21 1.5q-75 0-127.5-52.5T300-500q0-11 1.5-21t4.5-21l-84-82Zm319 93Zm-151 75Z"
                  />
                </svg>
              </div>
            </div>
          </div>

          <div class="my-3">
            <input
              class="mr-2 leading-tight"
              type="checkbox"
              v-model="isSavedLogin"
              id="sesion"
            />
            <label for="sesion" class="text-sm">Mantener la sesión iniciada</label>
          </div>
          
          <div class="flex w-full justify-center py-6">
            <btn-login
              class="px-4 py-2 text-center rounded-lg text-white tracking-wider uppercase font-bold"
              type="submit"
              :colorS="color_secundario"
            >
              Ingresar
            </btn-login>
          </div>
        </form>

        <div class="flex w-full justify-center">
          <button
            type="button"
            v-on:click="openResetPasswordModal()"
            class="hover:underline p-1"
          >¿Olvidaste tu contraseña?</button>
        </div>
        <div class="flex w-full justify-center">
          <button
            type="button"
            v-on:click="goToRegister()"
            class="hover:underline p-1"
          >Crear una nueva cuenta</button>
        </div>
      </div>
    </div>

    <piedepagina-gob-mx />

    <reset-password-modal
      :showing="showResetPasswordModal"
      @close="showResetPasswordModal = false"
      :colorP="color_principal"
      :colorS="color_secundario"
      :colorT="color_terciario"
    ></reset-password-modal>
    
    <alert-dialog :showing="showingError">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">{{ errorMessage }}</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-danger-color"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingError = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import urlMixin from "@/mixins/urlMixin";
import ResetPassword from "./ResetPassword";
import AlertDialog from "./AlertDialog";

import { styled } from "@egoist/vue-emotion";
import CabeceraGobMx from "./CabeceraGobMx.vue";
import PiedepaginaGobMx from "./PiedepaginaGobMx.vue";

const BtnLogin = styled("button")`
  background-color: ${(props) => props.colorS};
`;

export default {
  mixins: [urlMixin],
  data() {
    return {
      email: "",
      password: "",
      isSavedLogin: false,
      showResetPasswordModal: false,
      showingError: false,
      errorMessage: "",
      showPassword: false,
      url_image: "",
      color_principal: "",
      color_secundario: "",
      color_terciario: "",
      app_name: "",
    };
  },
  components: {
    "reset-password-modal": ResetPassword,
    AlertDialog,
    BtnLogin,
    CabeceraGobMx,
    PiedepaginaGobMx,
  },
  computed: {
    ...mapState(["loggingIn", "loginError", "accessToken"]),
  },
  methods: {
    ...mapActions(["doLogin"]),
    loginSubmit() {
      this.doLogin({
        email: this.email.trim(),
        password: this.password,
        isSavedLogin: this.isSavedLogin,
        type: "monitor",
      }).catch((error) => {
        this.errorMessage = error;
        this.showingError = true;
      });
    },
    openResetPasswordModal() {
      this.showResetPasswordModal = true;
    },
    goToRegister() {
      this.$router.push({ path: "/registro" });
    },
    changePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    fetchConfiguration() {
      this.axios
        .get("apidev/api/config/site")
        .then((response) => {
          let conf = response.data.config;
          this.url_image = conf.url_imagen;
          this.color_principal = conf.color_principal;
          this.color_secundario = conf.color_secundario;
          this.color_terciario = conf.color_terciario;
          this.app_name = conf.app_name;
        })
        .catch((error) => {
          // removed console log
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    },
  },
  beforeMount() {
    this.fetchConfiguration();
  },
};
</script>
